import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

export const ClientBilling = ({ formData, setFormData }: { formData: any, setFormData: any }) => {
    return (
        <Card className="border border-gray-100/80 shadow-sm bg-white">
            <CardHeader className="pb-3 bg-gray-50/50 border-b border-gray-100">
                <CardTitle className="text-base font-bold text-gray-900">Datos del Cobro y Facturación</CardTitle>
                <p className="text-xs text-gray-400">Configuración de medios de pago y cobro del cliente</p>
            </CardHeader>
            <CardContent className="space-y-6 pt-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-2">
                        <Label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Forma de Pago Habitual</Label>
                        <Input 
                            className="rounded-xl bg-white" 
                            placeholder="Ej. Transferencia Bancaria, Efectivo" 
                            value={formData.formaPago || ""}
                            onChange={e => setFormData({ ...formData, formaPago: e.target.value })}
                        />
                    </div>
                    <div className="space-y-2">
                        <Label className="text-xs font-bold text-gray-500 uppercase tracking-wider">Cuenta Bancaria de Referencia</Label>
                        <Input 
                            className="rounded-xl bg-white" 
                            placeholder="Ej. Bancolombia Ahorros 123-456..." 
                            value={formData.cuentaBancaria || ""}
                            onChange={e => setFormData({ ...formData, cuentaBancaria: e.target.value })}
                        />
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};
